(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luxglow-header-2"] && !Shopify.designMode) return;
  try {
    
  const initializeLuxHeaders = () => {
    document.querySelectorAll('[data-lux-announcements]:not([data-ready])').forEach((bar) => {
      bar.dataset.ready = 'true';
      const messages = Array.from(bar.querySelectorAll('[data-lux-message]'));
      if (messages.length < 2) return;
      let active = 0;
      let timer;
      const delay = Number(bar.dataset.interval) || 5000;
      const show = (next) => {
        messages[active].classList.remove('is-active');
        active = (next + messages.length) % messages.length;
        messages[active].classList.add('is-active');
      };
      const start = () => {
        window.clearInterval(timer);
        timer = window.setInterval(() => show(active + 1), delay);
      };
      bar.querySelector('[data-lux-prev]')?.addEventListener('click', () => { show(active - 1); start(); });
      bar.querySelector('[data-lux-next]')?.addEventListener('click', () => { show(active + 1); start(); });
      bar.addEventListener('mouseenter', () => window.clearInterval(timer));
      bar.addEventListener('mouseleave', start);
      start();
    });

    document.querySelectorAll('.lux-header__dropdown:not([data-ready])').forEach((dropdown) => {
      dropdown.dataset.ready = 'true';
      dropdown.addEventListener('toggle', () => {
        if (!dropdown.open) return;
        document.querySelectorAll('.lux-header__dropdown[open]').forEach((other) => {
          if (other !== dropdown) other.removeAttribute('open');
        });
      });
      dropdown.addEventListener('mouseenter', () => {
        if (window.matchMedia('(min-width: 750px)').matches) dropdown.setAttribute('open', '');
      });
      dropdown.addEventListener('mouseleave', () => {
        if (window.matchMedia('(min-width: 750px)').matches) dropdown.removeAttribute('open');
      });
    });
  };

  initializeLuxHeaders();
  document.addEventListener('shopify:section:load', initializeLuxHeaders);
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-lux-currency]')) return;
    event.target.form?.submit();
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('.lux-header__dropdown')) return;
    document.querySelectorAll('.lux-header__dropdown[open]').forEach((dropdown) => dropdown.removeAttribute('open'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
